'use client';

import { ChevronLeft, ChevronRight } from 'lucide-react';

type Props = {
  atStart: boolean;
  atEnd: boolean;
  onPrev: () => void;
  onNext: () => void;
};

/**
 * The paired prev / next arrow buttons that sit at the top of a phase carousel
 * card. Shared across `ProcessOverviewThreeStep` redesign and the
 * `SideHeaderCardsRow` carousel variant so both surfaces stay in sync.
 */
export function CarouselNavButtons({ atStart, atEnd, onPrev, onNext }: Props) {
  return (
    <div className="flex gap-2">
      <button
        type="button"
        onClick={onPrev}
        disabled={atStart}
        aria-label="Previous phase"
        className="flex size-11 items-center justify-center rounded-[8px] bg-[#d2d2d2] text-[#041118] transition-opacity hover:bg-[#c2c2c2] disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-[#d2d2d2]"
      >
        <ChevronLeft className="size-5" strokeWidth={2} />
      </button>
      <button
        type="button"
        onClick={onNext}
        disabled={atEnd}
        aria-label="Next phase"
        className="flex size-11 items-center justify-center rounded-[8px] bg-[#d2d2d2] text-[#041118] transition-opacity hover:bg-[#c2c2c2] disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-[#d2d2d2]"
      >
        <ChevronRight className="size-5" strokeWidth={2} />
      </button>
    </div>
  );
}
